<template>
     <section
    id="contact"
    class="contact_area bg_cover pt-120 pb-130"
    style="background-image: url(assets/images/contact_bg.jpg)"
  >
    <NotificationGroup group="foo">
      <div class="fixed inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none">
        <div class="w-full max-w-sm">
          <Notification
            v-slot="{ notifications, close }"
            enter="transform ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300"
          >
            <div
              class="w-full max-w-sm mt-4 overflow-hidden bg-white rounded-lg shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5"
              v-for="notification in notifications"
              :key="notification.id"
            >
              <div class="p-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <!--<svg class="w-6 h-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>-->
                  </div>
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p class="font-semibold text-gray-800">{{ notification.title }}</p>
                    <p class="text-sm font-semibold text-gray-500">{{ notification.text }}</p>
                  </div>
                  <div class="flex flex-shrink-0 ml-4">
                    <button @click="close(notification.id)" class="inline-flex text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400">
                      <span class="sr-only">Close</span>
                      <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Notification>
        </div>
      </div>
    </NotificationGroup>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="section_title section_title_2 text-center pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Contato
            </h4>
            <p
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              Preencha o formulário e entraremos em contato para melhor
              atende-lo!
            </p>
          </div>
        </div>
      </div>
      <form id="contact-form" class="wow fadeInUp">
        <div class="row">
          <div class="col-lg-6">
            <div class="single_form">
              <input
                type="text"
                placeholder="Nome"
                name="name"
                id="name"
                required
                v-model="fields.ClientName"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="single_form">
              <input
                type="email"
                placeholder="Email"
                name="email"
                id="email"
                required
                v-model="fields.ClientMail"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="single_form">
              <input
                type="text"
                placeholder="Número"
                name="number"
                id="number"
                required
                v-model="fields.ClientContato"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="single_form">
              <input
                type="text"
                placeholder="Objetivo"
                name="subject"
                id="subject"
                required
                v-model="fields.ClientAssunto"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <div class="single_form">
              <textarea
                placeholder="Mensagem"
                name="message"
                id="message"
                required
                v-model="fields.ClientMessage"
              ></textarea>
            </div>
          </div>
          <p class="form-message"></p>
          <div class="col-lg-12">
            <div class="single_form text-center">
              <button class="main-btn" @click="SendMail">Enviar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>

import axios from "axios";
import { notify } from "notiwind";

export default {
  //props: ['textconteudo', 'icon', 'title'],
    setup() {
    function onFail() {
      notify(
        {
          group: "foo",
          title: "Falha",
          text: "Mensagem não enviada tente novamente mais tarde",
        },
        4000
      );
    }
    function onSuccess(msg) {
      notify(
        {
          group: "foo",
          title: "Mensagem Enviada!",
          text: msg,
        },
        4000
      );
    }
    return {
      onFail,
      onSuccess,
    };
  },
  data() {
    return {
      fields: {
        EmailDestinatario: "genuinoalexsander@gmail.com",
        EmailRemetente: "alexsander.genuino.silva@gmail.com",
        ClientAssunto: "",
        ClientName: "",
        ClientMail: "",
        ClientContato: "",
        ClientMessage: "",
      },
    };
  },
  methods: {
    SendMail(e) {
      e.preventDefault()
      axios
        .post("http://localhost:45119/api/SendMail", this.fields)
        .then((res) => {

            this.onSuccess(res.data.message)
          
        })
        .catch(this.onFail());
    },
  },
};
</script>

<style scoped>

</style>